import { removeAllToasts } from '@medly-components/core';
import axios, { AxiosError } from 'axios';
import { SESSION_EXPIRED } from 'constants/common';
import { SOMETHING_WENT_WRONG, UNKNOWN_ERROR_OCCURRED } from 'constants/onboarding';
import { useLogoutFlow } from 'hooks/useLogout/useLogoutFlow';
import { useCallback } from 'react';
import { errorToast } from 'utils/utils';
import { isBeforeCaptureProfileRoute } from '../../utils/route';
import { checkErrorCode, isMantaCareError, isServerError } from './utils';

export const useErrorHandler = () => {
    const { logout } = useLogoutFlow();

    return useCallback(
        async (error: AxiosError) => {
            removeAllToasts();
            if (axios.isAxiosError(error) && checkErrorCode(error, 401)) {
                errorToast(SESSION_EXPIRED);
                await logout(true);
                return SESSION_EXPIRED;
            } else if (axios.isAxiosError(error) && isMantaCareError(error) && error.response && error.response.data) {
                const errorMessage =
                    isServerError(error) || !error.response.data.message ? SOMETHING_WENT_WRONG : error.response.data.message;
                const showToast = !isBeforeCaptureProfileRoute(window.location.pathname) && !checkErrorCode(error, 404);
                if (showToast) {
                    errorToast(errorMessage);
                }
                return errorMessage;
            } else {
                errorToast(UNKNOWN_ERROR_OCCURRED);
                return UNKNOWN_ERROR_OCCURRED;
            }
        },
        [logout]
    );
};
